document.addEventListener('DOMContentLoaded', function() {
  var hcFilteringEl = document.querySelector('.hc-filtering-slider');
  var hcSwiper = null;
  var main_gallery_children = [];
  if (hcFilteringEl && typeof Swiper !== 'undefined') {
    hcSwiper = new Swiper(hcFilteringEl, {
      direction: 'horizontal',
      slidesPerView: 5,
      speed: 8000,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        480: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 3, spaceBetween: 30 }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      autoplay: { delay: 5000 },
      loop: true,
      freeMode: true
    });
    main_gallery_children = Array.prototype.slice.call(hcFilteringEl.querySelectorAll('.swiper-slide'));
  }
  var container = document.querySelector('.hc-dropdown-container-filtering');
  if (container && hcSwiper) {
    var label = container.querySelector('.hc-label-filtering');
    var menu = container.querySelector('.hc-dropdown-filtering');
    if (label && menu) {
      label.addEventListener('click', function() {
        menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
      });
      menu.addEventListener('click', function(e) {
        var target = e.target;
        if (!(target && target.tagName)) return;
        if (target.tagName.toUpperCase() === 'DIV') {
          var selectedText = target.textContent.trim();
          label.textContent = selectedText;
          menu.style.display = 'none';
          var filtered = main_gallery_children.filter(function(slide) {
            return slide.dataset && slide.dataset.color === selectedText;
          });
          if (filtered.length) {
            hcSwiper.removeAllSlides();
            filtered.forEach(function(slide) {
              hcSwiper.appendSlide(slide);
            });
            hcSwiper.update();
            hcSwiper.slideTo(0, 0);
          }
        }
      });
      document.addEventListener('click', function(e) {
        if (container && !container.contains(e.target)) {
          menu.style.display = 'none';
        }
      });
    }
  }
  var hcSlideshowEl = document.querySelector('.hc-slideshow');
  if (hcSlideshowEl && typeof Swiper !== 'undefined') {
    var hcCustomSlideshow = new Swiper('.hc-slideshow', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 4,
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        480: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 3, spaceBetween: 30 },
        4048: { slidesPerView: 4, spaceBetween: 30 }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
});
